import styles from "./timeInput.module.css";

const TimeInput = ({ value, onChange }) => {
  return (
    <input
      type="time"
      step="3600000"
      onChange={(e) => onChange(e.target.value)}
      value={value}
      className={styles.timeInput}
    />
  );
};

export default TimeInput;
